import React, { useState, useEffect } from "react";
import axios from "../../EventDownloader";
import Icon from "../../components/UI/Icon/Icon";
import classes from "./EventOverview.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const EventOverview = props => {
    const [speciesSword, setSpeciesSword] = useState([]);
    const [speciesShield, setSpeciesShield] = useState([]);
    const [encounterRate, setEncounterRate] = useState(1);
    const [hasError, setError] = useState(false);
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);

    useEffect(() => {
        axios.get(props.filename).then(
            resp => {
                setEncounterRate(resp.data.Tables[0]["EncounterRate"])
                const usedUp = new Set();
                setSpeciesSword(resp.data.Tables[0]["Entries"].reduce(((prev, cur) => {
                    const tmp = cur.Species + cur.AltForm + "." + cur.IsGigantamax + "." + cur.ShinyForced;
                    if(!cur.Exists || usedUp.has(tmp)) {
                        return prev;
                    } else {
                        usedUp.add(tmp);
                        return prev.concat(cur);
                    }
                }), []).map((v, idx) => <Icon details={v} key={idx} />));
                usedUp.clear();
                setSpeciesShield(resp.data.Tables[1]["Entries"].reduce(((prev, cur) => {
                    const tmp = cur.Species + cur.AltForm + "." + cur.IsGigantamax + "." + cur.ShinyForced;
                    if(!cur.Exists || usedUp.has(tmp)) {
                        return prev;
                    } else {
                        usedUp.add(tmp);
                        return prev.concat(cur);
                    }
                }), []).map((v, idx) => <Icon details={v} key={idx} />));
            }
        ).catch(error => {
            setError(true);
        });
    }, [props.filename]);

    if (hasError) return null;

    const headline = props.filename.substr(0, 2) + "-" + props.filename.substr(2, 2) + "-" + props.filename.substr(4, 2);
    const linkTo = props.filename.substr(0, 6) + (props.filename.endsWith("_1.json") ? "_1" : "");
    return (
        <Link className={classes.Wrapper} to={"/event/" + linkTo}>
            <h2 className={classes.Break}>{headline}</h2>
            <p className={classes.Break}><strong>{t("APPEARANCERATE")}: </strong> {100 * encounterRate / 16}%</p>
            <div className={classes.GameWrapper}>
                <strong>{t("GAMESWORD")}</strong>
                <div className={classes.Break} />
                {speciesSword}
            </div>
            <div className={classes.GameWrapper}>
                <strong>{t("GAMESHIELD")}</strong>
                <div className={classes.Break} />
                {speciesShield}
            </div>
        </Link>
    );
}

export default EventOverview;